import React, { useState } from 'react';

import TabBar from '../../components/Navbar/TabBar/TabBar';
import ProjectCardContainer from '../../components/ProjectOverviewComponents/ProjectCardContainer/ProjectCardContainer';
import {
  ProjectOverviewView,
  ProjectOverviewViewEnum,
} from '../../types/enums/ProjectOverviewViewEnum';

const ProjectOverview = () => {
  const [activeProjectView, setActiveProjectView] = useState<ProjectOverviewView>(
    ProjectOverviewViewEnum.Active,
  );

  return (
    <div>
      <TabBar
        onChangeProjectView={(activeView: ProjectOverviewView) => {
          setActiveProjectView(activeView);
        }}
        activeProjectView={activeProjectView}
      />
      <ProjectCardContainer
        activeProjectView={activeProjectView}
        onChangeProjectView={(activeView: ProjectOverviewView) => {
          setActiveProjectView(activeView);
        }}
      />
    </div>
  );
};

export default ProjectOverview;
